// src/pages/index.js
import { lazy } from "react";

/* ---------- AUTH (public) ---------- */
export const SignIn         = lazy(() => import("./Auth/SignIn.jsx"));
export const SignUp         = lazy(() => import("./Auth/SignUp.jsx"));
export const ForgotPassword = lazy(() => import("./Auth/ForgotPassword.jsx"));
export const ResetPassword  = lazy(() => import("./Auth/ResetPassword.jsx"));

/* ---------- PRIVATE (dashboard & user) ---------- */
export const Dashboard    = lazy(() => import("./Dashboard/Dashboard.jsx"));
export const Profile      = lazy(() => import("./Profile/Profile.jsx"));
export const EditProfile      = lazy(() => import("./Profile/EditProfile.jsx"));
export const Notification = lazy(() => import("./Notification/Notification.jsx"));

/* ---------- PRIVATE (project flows) ---------- */
export const Project               = lazy(() => import("./Project/Project.jsx"));
export const ProjectDetails        = lazy(() => import("./Project/ProjectDetails.jsx"));
export const ProjectFunding        = lazy(() => import("./ProjectFunding/ProjectFunding.jsx"));
export const ProjectFundingDetails = lazy(() => import("./ProjectFunding/ProjectFundingDetails.jsx"));

export const Ideation        = lazy(() => import("./Ideation/Ideation.jsx"));
export const Funding         = lazy(() => import("./Funding/Funding.jsx"));
export const IdeationSummary = lazy(() => import("./Ideation/IdeationSummary.jsx"));
export const FundingSummary  = lazy(() => import("./Funding/FundingSummary.jsx"));

export const Transaction = lazy(() => import("./Transaction/Transaction.jsx"));
export const Log         = lazy(() => import("./Log/Log.jsx"));
export const LogDetail   = lazy(() => import("./Log/LogDetail.jsx"));
export const KycAdd      = lazy(() => import("./Kyc/KycAdd.jsx"));
export const KycSubmitted = lazy(() => import("./KycSubmitted/KycSubmitted.jsx"));
/* ---------- Utility ---------- */
export const NotFound = lazy(() => import("./NotFound/NotFound.jsx"));
